document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("coffeeSlider");
  slider.value = 3;
  const cupsDisplay = document.querySelector(".cups-display");

  const contentData = [
    // 1 Tasse
    {
      weight1: "1x 250g",
      period1: "alle 25 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_250g.svg?v=1686500607",
    },
    // 2 Tassen
    {
      weight1: "250g",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_250g.svg?v=1686500607",
      weight2: "500g",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_500g.svg?v=1686500608",
    },
    // 3 Tassen
    {
      weight1: "500g",
      period1: "alle 17 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_500g.svg?v=1686500608",
      weight2: "500g + 250g",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_500g_250g.svg?v=1686500608",
    },
    // 4 Tassen
    {
      weight1: "500g",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_500g.svg?v=1686500608",
      weight2: "1kg",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg.svg?v=1686500608",
    },
    // 5 Tassen
    {
      weight1: "500g + 250g",
      period1: "alle 15 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_500g_250g.svg?v=1686500608",
      weight2: "1kg + 250g",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg_250g.svg?v=1686500607",
    },
    // 6 Tassen
    {
      weight1: "500g + 250g",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_500g_250g.svg?v=1686500608",
      weight2: "1kg + 500g",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg_500g.svg?v=1686500608",
    },
    // 7 Tassen
    {
      weight1: "1kg",
      period1: "alle 14 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg.svg?v=1686500608",
      weight2: "2x 1kg",
      period2: "alle 29 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_2x1kg.svg?v=1686500607",
    },
    // 8 Tassen
    {
      weight1: "1kg",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg.svg?v=1686500608",
      weight2: "2x 1kg",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_2x1kg.svg?v=1686500607",
    },
    // 9 Tassen
    {
      weight1: "1kg + 250g",
      period1: "alle 14 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg_250g.svg?v=1686500607",
      weight2: "3x 1kg",
      period2: "alle 33 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_3x1kg.svg?v=1686500608",
    },
    // 10 Tassen
    {
      weight1: "1kg + 250g",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg_250g.svg?v=1686500607",
      weight2: "3x 1kg",
      period2: "alle 30 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_3x1kg.svg?v=1686500608",
    },
    // 11 Tassen
    {
      weight1: "1kg + 500g",
      period1: "alle 14 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg_500g.svg?v=1686500608",
      weight2: "3x 1kg",
      period2: "alle 27 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_3x1kg.svg?v=1686500608",
    },
    // 12 Tassen
    {
      weight1: "1kg + 500g",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_1kg_500g.svg?v=1686500608",
      weight2: "3x 1kg",
      period2: "alle 25 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_3x1kg.svg?v=1686500608",
    },
    // 13 Tassen
    {
      weight1: "2x 1kg",
      period1: "alle 15 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_2x1kg.svg?v=1686500607",
      weight2: "4x 1kg",
      period2: "alle 31 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_4x1kg.svg?v=1686500607",
    },
    // 14 Tassen
    {
      weight1: "2x 1kg",
      period1: "alle 14 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_2x1kg.svg?v=1686500607",
      weight2: "4x 1kg",
      period2: "alle 29 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_4x1kg.svg?v=1686500607",
    },
    // 15 Tassen
    {
      weight1: "2x 1kg",
      period1: "alle 13 Tage",
      imgSrc1:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_2x1kg.svg?v=1686500607",
      weight2: "4x 1kg",
      period2: "alle 27 Tage",
      imgSrc2:
        "https://cdn.shopify.com/s/files/1/0671/2999/9625/files/Joe_4x1kg.svg?v=1686500607",
    },
  ];

  const rightColumn = document.querySelector(
    ".joe-coffee-calculator-info-bag-display"
  );

  function createContentElements() {
    contentData.forEach((content, index) => {
      const valueContent = document.createElement("div");
      valueContent.classList.add("value-content");
      valueContent.dataset.index = index;
      valueContent.style.display = "flex";

      // Create first child div
      const child1 = document.createElement("div");
      const img1 = document.createElement("img");
      img1.src = content.imgSrc1;
      img1.alt = content.weight1;
      child1.appendChild(img1);

      const weight1 = document.createElement("p");
      weight1.innerText = content.weight1;
      weight1.classList.add("bold");
      child1.appendChild(weight1);

      const period1 = document.createElement("p");
      period1.innerText = content.period1;
      period1.classList.add("text-sm");
      child1.appendChild(period1);

      // Append first child div to valueContent
      valueContent.appendChild(child1);

      // Check if it's not the first item
      if (index !== 0) {
        // Create "or" element
        const orElement = document.createElement("p");
        orElement.innerText = "oder";
        orElement.classList.add(
          "h5",
          "joe-coffee-calculator-or-vertical-center"
        );
        valueContent.appendChild(orElement);

        // Create second child div
        const child2 = document.createElement("div");
        const img2 = document.createElement("img");
        img2.src = content.imgSrc2;
        img2.alt = content.weight2;
        child2.appendChild(img2);

        const weight2 = document.createElement("p");
        weight2.innerText = content.weight2;
        weight2.classList.add("bold");
        child2.appendChild(weight2);

        const period2 = document.createElement("p");
        period2.innerText = content.period2;
        period2.classList.add("text-sm");
        child2.appendChild(period2);

        // Append second child div to valueContent
        valueContent.appendChild(child2);
      }

      rightColumn.appendChild(valueContent);
    });
  }

  createContentElements();

  function updateCupsDisplay(cups) {
    const cupsDisplay = document.getElementById("cup-text");
    cupsDisplay.textContent = cups;
  }

  function showValueContent(index) {
    const valueContainers = document.querySelectorAll(".value-content");
    valueContainers.forEach((container) => {
      if (parseInt(container.dataset.index) === index) {
        container.style.transform = "translateX(-50%) translateY(0)";
        container.style.opacity = "1";
      } else {
        container.style.transform = "translateX(-50%) translateY(-100%)";
        container.style.opacity = "0";
      }
    });
  }

  function applyFallAndBounceAnimation(index) {
    const valueContainers = document.querySelectorAll(".value-content");
    valueContainers.forEach((container) => {
      if (parseInt(container.dataset.index) === index) {
        container.style.animation = "fallAndBounce 0.4s";
        const imgs = container.querySelectorAll("img");
        imgs.forEach((img) => (img.style.animation = "imgShrink 0.4s"));
      } else {
        container.style.animation = "";
        const imgs = container.querySelectorAll("img");
        imgs.forEach((img) => (img.style.animation = ""));
      }
    });
  }

  function applyRotateAndSettleAnimation() {
    const cup = document.querySelector(".joe-coffee-calculator-jumping-cup");
    cup.style.animation = "none"; // Remove animation
    cup.offsetHeight; // Trigger reflow
    cup.style.animation = "rotateAndSettle 0.3s 0.2s"; // Reapply animation
  }

  slider.addEventListener("input", () => {
    const cups = slider.value;
    updateCupsDisplay(cups);
    if (!isMouseDown) {
      showValueContent(cups - 1);
      applyRotateAndSettleAnimation(); // Cup animation
    }
  });

  let isMouseDown = false;

  slider.addEventListener("mousedown", () => {
    isMouseDown = true;
  });

  slider.addEventListener("mouseup", () => {
    isMouseDown = false;
    setTimeout(() => {
      showValueContent(slider.value - 1);
      applyFallAndBounceAnimation(slider.value - 1);
      applyRotateAndSettleAnimation(); // Cup animation
    }, 100);
  });

  // Added touch events
  slider.addEventListener("touchstart", () => {
    isMouseDown = true;
  });

  slider.addEventListener("touchend", () => {
    isMouseDown = false;
    showValueContent(slider.value - 1);
    applyFallAndBounceAnimation(slider.value - 1);
    applyRotateAndSettleAnimation(); // cup animation
  });

  // Initial update on page load
  slider.dispatchEvent(new Event("input"));
});